<script>
/**
 * ****************************************************************************
 * @description     :   MainLayout
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * import template
 */
import template from './template.html';

/**
 * import component
 */
import MainMenu from '@/shared/menu';
import HeaderError from '@/components/headerError';
import Loading from '@/components/loading';
import MainHeader from '@/shared/header';
import MainFooter from '@/shared/footer';
import ModalMessage from '@/shared/modal-message';
import GlobalPopup from '@/shared/global-popup/index.vue';
import GlobalWidget from '@/shared/global-widget/index.vue';
import GlobalWrapper from '@/shared/global-wrapper/index.vue';
import helpers from '@/utils/helpers';
import { mapState, mapActions, mapMutations } from 'vuex';
import { SYSTEM_COLORS, timeoutFocus } from '@/utils/constants';
import _ from 'lodash';
/**
 * Define main layout
 */
export default {
    name: 'MainLayout',
    template: template,
    components: {
        MainMenu,
        MainHeader,
        HeaderError,
        Loading,
        ModalMessage,
        MainFooter,
        GlobalPopup,
        GlobalWidget,
        GlobalWrapper
    },
    data() {
        let isDefaultColorSettings = false;
        if (localStorage.getItem('mainColor') == null || localStorage.getItem('subColor') == null || localStorage.getItem('backColor') == null) {
            isDefaultColorSettings = true;
        }
        const mainColor = JSON.parse(localStorage.getItem('mainColor'));
        const subColor = JSON.parse(localStorage.getItem('subColor'));
        const backColor = JSON.parse(localStorage.getItem('backColor'));
        // check customer module or manager module
        let isManager = localStorage.getItem('mode') == 1 ? true : false;
        return {
            isPinIconLeftMenu: localStorage.getItem('isPinIconLeftMenu') === 'true' ? true : false,
            isShowBtnLeftMenu: true,
            zoomLevel: 100, // Default zoom level
            mainColor: mainColor,
            subColor: subColor,
            backColor: backColor,
            defaultColorSettings: isDefaultColorSettings,
            isManager: isManager
        };
    },
    watch: {
        $route() {
            this.focusFirstInput();
            this.trackingRoute();
        }
    },
    created() {
        this.trackingRoute();
    },
    mounted() {
        this.patchTabindex();
        // document.addEventListener('keydown', this.handleKeydown);
        this.focusFirstInput();
        this.actionKeyCode();
        this.checkZoomLevel();
        window.addEventListener('resize', this.checkZoomLevel);
        // document.addEventListener('shown.bs.modal', this.popupFocus);

        // reload other pages when change setting color
        window.addEventListener('storage', (event) => {
            const colorKeys = ['mainColor', 'subColor', 'backColor'];
            const mainColor = JSON.parse(localStorage.getItem('mainColor'));
            const subColor = JSON.parse(localStorage.getItem('subColor'));
            const backColor = JSON.parse(localStorage.getItem('backColor'));
            if (colorKeys.includes(event.key) && event.oldValue != event.newValue && event.newValue != null) {
                this.mainColor = mainColor;
                this.subColor = subColor;
                this.backColor = backColor;
                this.defaultColorSettings = false;
            } else {
                this.defaultColorSettings = true;
            }
        });
    },
    updated() {
        this.patchTabindex();
    },
    beforeUnmount() {
        // document.removeEventListener('keydown', this.handleKeydown);
        window.removeEventListener('resize', this.checkZoomLevel);
        // document.addEventListener('shown.bs.modal', this.popupFocus);
    },
    computed: {
        ...mapState('app', ['isShowLeftMenu', 'isExistsLeftMenu', 'header', 'isFaqLayout', 'isScroll']),
        isMobile() {
            return helpers.checkIfMobile();
        },
        keepAlivePages() {
            return ['CUS_Register001', 'CUS_Register002', 'CUS_Register003', 'CUS_Register004'];
        }
    },
    methods: {
        ...mapMutations('app', ['showModalMessage', 'hideModalMessage', 'setZoom', 'setShowLeftMenu', 'setExistsLeftMenu']),
        ...mapActions('app', ['setOpenSideBar']),
        trackingRoute() {
            const user = JSON.parse(localStorage.getItem('userInfo'));
            if (_.isEmpty(user)) return;

            const exceptListScreen = [
                'CUS_Start001',
                'CUS_Start002',
                'CUS_Start003',
                'CUS_Start004',
                'CUS_Start011',
                'CUS_Register001',
                'CUS_Register002',
                'CUS_Register003',
                'CUS_Register004',
                'CUS_Register005',
                'CUS_System903',
                'MNG_System903'
            ];
            if (exceptListScreen.includes(this.$route.name)) {
                this.setExistsLeftMenu(false);
            } else {
                this.setExistsLeftMenu(true);
            }
        },
        // toggle icon pin left menu
        onClickIconPinLeftMenu() {
            this.isPinIconLeftMenu = !this.isPinIconLeftMenu;
            localStorage.setItem('isPinIconLeftMenu', this.isPinIconLeftMenu);
        },
        patchTabindex() {
            this.$nextTick(() => {
                this.$el.querySelectorAll('.dropdown-toggle').forEach((btn) => {
                    btn.setAttribute('tabindex', '-1');
                });
            });
        },
        // update status icon pin left menu
        handleIconPinLeftMenu(status) {
            this.isPinIconLeftMenu = status;
        },
        // toggle left menu
        onClickBtnLeftMenu() {
            if (this.isPinIconLeftMenu) return;
            this.setShowLeftMenu(!this.isShowLeftMenu);
            this.setOpenSideBar(this.isShowLeftMenu);
        },
        // // show/hide BUTTON left menu
        // handleBtnLeftMenu(status) {
        //     if (this.isPinIconLeftMenu) return;
        //     console.log('handleBtnLeftMenu');
        //     this.setShowLeftMenu(status);
        //     this.setOpenSideBar(true);
        // },
        // show/hide left menu
        handleLeftMenu(status) {
            if (this.isPinIconLeftMenu) return;
            this.setShowLeftMenu(status);
        },
        onClickOutside() {
            this.setShowLeftMenu(false);
        },
        checkZoomLevel() {
            // Calculate the zoom level
            const zoom = Math.round(window.devicePixelRatio * 100);
            this.zoomLevel = zoom;
            this.setZoom(this.isMobile ? 100 : zoom);
            // Show the popup if zoom level is outside the range
            if (this.zoomLevel <= 50 || this.zoomLevel >= 150) {
                var content_msg = '';
                if (this.zoomLevel >= 150) {
                    content_msg = 'Webブラウザのズーム設定がもっと大きい場合、レイアウトがずれる可能性があります。';
                } else {
                    content_msg = 'Webブラウザのズーム設定がもっと小さい場合、レイアウトがずれる可能性があります。';
                }
                if (window.screen.width >= 835) {
                    this.showModalMessage({
                        type: 2,
                        title: '警告',
                        content: content_msg,
                        okText: 'はい',
                        callback: () => {}
                    });
                }
            } else {
                this.hideModalMessage();
            }
        },
        focusFirstInput() {
            setTimeout(() => {
                const screenId = helpers.checkScreenId();

                if (screenId.match(/^-?\d+$/)) return;

                if (screenId == 'CUS_Order001') {
                    this.$el.querySelector('#start_time').focus();
                } else {
                    var firstInput = this.$el?.querySelector('#' + screenId)?.querySelectorAll('input,select');
                    var i = 0;
                    if (firstInput) {
                        for (i; i < firstInput.length; i++) {
                            if (
                                firstInput[i].disabled == false &&
                                firstInput[i].type != 'hidden' &&
                                !firstInput[i].classList.contains('input-multi-cal-hidden')
                            ) {
                                firstInput[i].focus();
                                break;
                            }
                        }
                    }
                }
            }, timeoutFocus);
        },
        // handleKeydown(event) {
        //     console.log(event);
        // },
        //     const commonButton = document.getElementById('common-button');
        //     const commonSearch = document.getElementById('common-search');
        //     const commonSearchDetails = document.getElementById(
        //         'common-search-details'
        //     );
        //     const buttonSubmit = document.getElementById('button-submit');
        //     const buttonDelete = document.getElementById('button-delete');
        //     const buttonCreate = document.getElementById('button-create');
        //     const buttonBack = document.getElementById('button-back');
        //     // Helper function to check if the button has 'not_back_index' class
        //     const hasNotBackIndexClass = (button) =>
        //         button && button.classList.contains('not_back_index');

        //     if (document.activeElement == commonSearchDetails) {
        //         if (buttonBack == null) {
        //             event.preventDefault();
        //             this.focusFirstInput();
        //         } else {
        //             event.preventDefault();
        //             this.$el.querySelector('#button-back').focus();
        //         }
        //     }

        //     if (
        //         (document.activeElement == buttonCreate &&
        //             commonButton == null &&
        //             !hasNotBackIndexClass(buttonCreate)) ||
        //         (document.activeElement == commonButton &&
        //             !hasNotBackIndexClass(commonButton)) ||
        //         (document.activeElement == buttonDelete &&
        //             !hasNotBackIndexClass(buttonDelete))
        //     ) {
        //         if (buttonBack == null) {
        //             event.preventDefault();
        //             this.focusFirstInput();
        //         } else {
        //             event.preventDefault();
        //             this.$el.querySelector('#button-back').focus();
        //         }
        //     }

        //     if (
        //         document.activeElement == commonSearch &&
        //         buttonCreate == null &&
        //         !hasNotBackIndexClass(commonSearch)
        //     ) {
        //         if (buttonBack == null) {
        //             event.preventDefault();
        //             this.focusFirstInput();
        //         } else {
        //             event.preventDefault();
        //             this.$el.querySelector('#button-back').focus();
        //         }
        //     }

        //     if (
        //         document.activeElement == buttonSubmit &&
        //         commonButton == null &&
        //         buttonDelete == null &&
        //         !hasNotBackIndexClass(buttonSubmit)
        //     ) {
        //         if (buttonBack == null) {
        //             event.preventDefault();
        //             this.focusFirstInput();
        //         } else {
        //             event.preventDefault();
        //             this.$el.querySelector('#button-back').focus();
        //         }
        //     }
        // },
        // popupFocus() {
        //     if (document.querySelectorAll('.modal.show').length > 0) {
        //         var popupName = document.querySelectorAll('.modal.show')[0].id;
        //         if (popupName != 'modal-no-backdrop') {
        //             var firstPopup = document
        //                 .querySelector('#' + popupName)
        //                 .querySelectorAll('input,select');
        //             var i = 0;
        //             for (i; i < firstPopup.length; i++) {
        //                 if (firstPopup[i].disabled == false) {
        //                     firstPopup[i].focus();
        //                     break;
        //                 }
        //             }
        //         } else {
        //             var firstButton = document.querySelectorAll(
        //                 '#modal-no-backdrop .btn-common'
        //             )[0];
        //             firstButton.focus();
        //         }
        //     }
        // },
        actionKeyCode() {
            window.addEventListener('keydown', (e) => {
                const modal = document.getElementsByClassName('modal-backdrop fade show');
                const openModal = !!modal.length;
                const confirmModal = document.getElementsByClassName('modal fade custom-modal modal-second show');
                //f4 search
                if (e.keyCode == 115) {
                    e.preventDefault();
                    document.getElementById('common-search')?.click();
                }
                //f9 save
                if (e.keyCode == 120) {
                    e.preventDefault();
                    if (openModal) {
                        if (confirmModal.length) {
                            return false;
                        }
                        document.getElementById('button-submit-modal')?.click();
                    } else {
                        document.getElementById('button-create')?.click();
                        document.getElementById('button-submit')?.click();
                    }
                }
                //f12 back
                if (e.keyCode == 123) {
                    e.preventDefault();
                    if (openModal) {
                        if (confirmModal.length) {
                            return false;
                        }
                        document.getElementById('button-back-modal')?.click();
                    } else {
                        document.getElementById('button-back')?.click();
                    }
                    return false;
                }
                //f10 print
                if (e.keyCode == 121) {
                    e.preventDefault();
                    document.getElementById('button-print')?.click();
                    return false;
                }
            });
        },
        findColorByName(name) {
            return SYSTEM_COLORS.find((color) => color.NAME === name);
        }
    }
};
</script>
<style lang="scss">
@import 'handsontable/dist/handsontable.full.css';
@import 'flatpickr/dist/flatpickr.css';
@import 'https://fonts.googleapis.com/earlyaccess/sawarabigothic.css';
@import 'https://fonts.googleapis.com/css?family=Roboto:400,300,100,500,700,900';
</style>
